import { render, staticRenderFns } from "./WizzardCard.vue?vue&type=template&id=248dac44&scoped=true&"
import script from "./WizzardCard.vue?vue&type=script&lang=js&"
export * from "./WizzardCard.vue?vue&type=script&lang=js&"
import style0 from "./WizzardCard.vue?vue&type=style&index=0&id=248dac44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248dac44",
  null
  
)

export default component.exports